import { type CampaignCreative, type DynamicYieldCampaign } from '../../../shared/types';
import { CampaignType } from '../../enums/CampaignType';
import { useCampaigns } from '../../hooks/useCampaigns';
import { DynamicYieldHeaderBanner } from './DynamicYieldHeaderBanner';
import { HeaderBanner } from './HeaderBanner/HeaderBanner';

type CampaignProps = {
    readonly type?: CampaignType;
};

const Campaign = ({ type = CampaignType.Creative }: CampaignProps): JSX.Element | null => {
    const { hasCampaigns, headerBanner } = useCampaigns<CampaignCreative>(type);

    if (!hasCampaigns || !headerBanner || (!headerBanner.text && type === CampaignType.Creative)) {
        return null;
    }

    if (type === CampaignType.Creative) {
        return <HeaderBanner creative={headerBanner} />;
    }

    return <DynamicYieldHeaderBanner creative={headerBanner as unknown as DynamicYieldCampaign} />;
};

export { Campaign };
